// WebsiteIndividual.js
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CommentCard from "../../components/CommentCard";
export const BlogIndividual = () => {
  const { blogId } = useParams();
  const [blog, setBlog] = useState(null);
  const [interaction, setInteraction] = useState(null);
  const [richTextContent, setRichTextContent] = useState(null);

  const getBlog = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/blogs/indi/${blogId}`,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      console.log(data);
      setBlog(data.blogs);
      setInteraction(data.interaction);
    } catch (error) {
      console.log(error);
    }
  };
  const navigate = useNavigate();
  useEffect(() => {
    async function getInfo() {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/verify`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (data.message === "Please login first") {
          navigate("/adminLogin");
        }
      } catch (error) {
        console.log(error);
      }
    }
    getInfo();
  }, []);
  useEffect(() => {
    getBlog();
  }, []);

  useEffect(() => {
    if (blog?.richTextContent) {
      fetch(blog.richTextContent)
        .then((response) => response.text())
        .then((content) => setRichTextContent(content))
        .catch((error) =>
          console.error("Error fetching rich text content:", error)
        );
    } else {
      setRichTextContent("");
    }
  }, [blog?.richTextContent]);

  if (!blog) {
    return <div>Loading...</div>;
  }

  return (
    <Paper elevation={3} style={{ padding: "5rem", margin: "20px" }}>
      <Typography variant="h4">{blog && blog.title}</Typography>
      <Typography variant="subtitle1" mt={"1rem"} fontWeight={"700"}>
        Author:
      </Typography>
      <Typography variant="subtitle2" mb={"1rem"}>
        {blog && blog.user_id && blog.user_id.name}
      </Typography>

      <Typography variant="subtitle1" mt={"1rem"} fontWeight={"700"}>
        Published Date:
      </Typography>
      <Typography variant="subtitle2" mb={"1rem"}>
        {blog && new Date(blog.time).toLocaleDateString()}
      </Typography>

      <Card style={{ margin: "2rem 0" }}>
        <CardContent>
          <Typography variant="body1">{blog && blog.content}</Typography>
        </CardContent>
      </Card>
      <Card style={{ margin: "2rem 0" }}>
        <CardContent>
          <div dangerouslySetInnerHTML={{ __html: richTextContent }} />
        </CardContent>
      </Card>

      {/* Add more details based on your blog data */}
      <Typography variant="subtitle1" mt={"4rem"} fontWeight={"700"}>
        Tags:
      </Typography>
      <Typography variant="subtitle1">{blog && blog.tags}</Typography>
      <Typography variant="subtitle1" mt={"0.5rem"} fontWeight={"700"}>
        Like Count:
      </Typography>
      <Typography variant="subtitle1" mb={"0.5rem"}>
        {blog && blog.like}
      </Typography>
      <Typography variant="subtitle1" fontWeight={"700"}>
        Read Time (minutes):
      </Typography>
      <Typography variant="subtitle1">{blog && blog.read_time}</Typography>

      {/* Render items, if available */}
      {blog && blog.items && blog.items.length > 0 && (
        <div>
          <Typography variant="h6" mt={"1rem"} mb={"1rem"} fontWeight={"700"}>
            Images:
          </Typography>
          {blog.items.map((item) => (
            <img
              key={item._id}
              src={`https://${item.bucket}.s3.${item.region}.amazonaws.com/${item.s3Key}`}
              alt="Blog Images"
              style={{ maxWidth: "30%", margin: "10px 0" }}
            />
          ))}
        </div>
      )}
      <Typography variant="h6" mt={"2rem"} mb={"1rem"} fontWeight={"700"}>
        Comments:
      </Typography>
      {interaction.map(
        (i) =>
          i.interaction_type === "comment" && (
            <CommentCard
              content={i.interaction_content}
              commentUserName={i.user_id.name}
              cId={i._id}
              bId={i.blog_id}
              uId={i.user_id._id}
              time={i.time}
              repliesArray={i.replies}
            />
          )
      )}
    </Paper>
  );
};
